( ( { hooks: { addFilter: addFilterBe } }, { hooks: { addFilter: addFilterFe } } ) => {
  // Backend Filters
  addFilterBe(
    'b3rg_btn_attr_buttonTitle_default_val',
    'b3rg/button',
    // eslint-disable-next-line no-unused-vars
    ( _defaultValue ) => {
      return 'Hello World!';
    }
  );

  // Frontend Hooks
  addFilterFe(
    'b3rg_btn_frontend_console_msg',
    'b3rg/button',
    // eslint-disable-next-line no-unused-vars
    ( _defaultValue ) => 'This appears only on Frontend so I customized it from theme 😱'
  );
// eslint-disable-next-line no-undef
} )( wp, feWp );


